import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import SwipeSlider from '@src/components/SwipeSlider';
import IconFilter from '@src/components/Icon/set/IconFilter';
import IconCloseS from '@src/components/Icon/set/IconCloseS';

import css from './style.module.scss';

const TagFilters = (props) => {
	const {
		suggests,
		filters,
		Modal,
		onManageFiltersClick,
		onFilterDeleteClick,
		onSuggestClick,
		wrapperMods,
		sliderTrackMix,
		sliderWrapMix,
		wrapId,
		suggestMod,
	} = props;

	const handleFilterDeleteClick = useCallback(
		(filter) => {
			if (onFilterDeleteClick) onFilterDeleteClick(filter);
		},
		[onFilterDeleteClick],
	);

	const handleSuggestClick = useCallback(
		(suggest) => {
			if (onSuggestClick) onSuggestClick(suggest);
		},
		[onSuggestClick],
	);

	return (
		<div className={cn(wrapperMods)} id={wrapId}>
			<SwipeSlider
				arrowsPos="center"
				slideMix={css.slide}
				trackMix={sliderTrackMix}
				wrapMix={sliderWrapMix}
			>
				{Modal && <Modal />}
				{onManageFiltersClick && (
					<span
						className={cn(css.filterBtn, {
							[css.filterBtn_active]: filters.length > 0,
						})}
						onClick={onManageFiltersClick}
						role="button"
						tabIndex={0}
					>
						<IconFilter className={css.filterIcon} />
						<span className={css.btnText}>{t('Фильтры')}</span>
						{filters.length > 0 && (
							<span className={css.activeMark} />
						)}
					</span>
				)}
				{filters.map((filter) => (
					<div
						className={cn(css.selectedBtn)}
						key={`${filter.value}-${filter.name}-${filter.title}`}
					>
						<span className={css.btnText}>{filter.title}</span>
						<span
							tabIndex={0}
							role="button"
							className={css.closeBtn}
							onClick={() => handleFilterDeleteClick(filter)}
						>
							<IconCloseS className={css.closeIcon} />
						</span>
					</div>
				))}
				{suggests.map((suggest, index) => {
					const itemNode = (
						<span
							key={suggest.value}
							tabIndex={0}
							role="button"
							className={cn(css.filterBtn, {
								[css[`filterBtn_${suggestMod}`]]: suggestMod,
							})}
							onClick={() => handleSuggestClick(suggest)}
						>
							<span className={css.btnText}>{suggest.title}</span>
						</span>
					);
					if (index === 0) {
						return (
							<span
								className={css.suggestWrap}
								key={suggest.value}
							>
								{itemNode}
							</span>
						);
					}
					return itemNode;
				})}
			</SwipeSlider>
		</div>
	);
};

TagFilters.propTypes = {
	suggests: PropTypes.arrayOf(
		PropTypes.shape({
			value: PropTypes.string,
			title: PropTypes.string,
			name: PropTypes.string,
		}),
	),
	filters: PropTypes.arrayOf(
		PropTypes.shape({
			value: PropTypes.string,
			title: PropTypes.string,
			name: PropTypes.string,
		}),
	),
	Modal: PropTypes.elementType,
	onManageFiltersClick: PropTypes.func,
	onFilterDeleteClick: PropTypes.func,
	onSuggestClick: PropTypes.func,
	wrapperMods: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.string),
		PropTypes.string,
	]),
	sliderTrackMix: SwipeSlider.type.propTypes.trackMix,
	sliderWrapMix: SwipeSlider.type.propTypes.wrapMix,
	wrapId: PropTypes.string,
	suggestMod: PropTypes.oneOf(['grey']),
};

TagFilters.defaultProps = {
	suggests: [],
	filters: [],
	Modal: undefined,
	onManageFiltersClick: undefined,
	onFilterDeleteClick: undefined,
	onSuggestClick: undefined,
	wrapperMods: undefined,
	sliderTrackMix: undefined,
	sliderWrapMix: undefined,
	suggestMod: undefined,
	wrapId: undefined,
};

export default TagFilters;
